import React                       from 'react';
import TarificationStep            from 'components/wizard/tarification_step';
import ProductFactoryStep          from 'components/wizard/product_factory/product_factory_step';
import { Condition }               from 'models/condition/condition';
import getAxaFleetTarificationForm from 'components/axa/fleet/tarification_form';
import { getTarificationSteps }    from 'schemas/shared/tarification_steps';

import policyOwnerSchema      from 'schemas/product_factory/tpe/policy_owner_schema.json';
import guaranteeTypesSchema   from 'schemas/product_factory/tpe/guarantee_types_schema.json';
import workerCompSchema       from 'schemas/product_factory/tpe/worker_compensation_schema.json';
import complementaryLawSchema from 'schemas/product_factory/tpe/complementary_law_schema.json';
import householdSchema        from 'schemas/product_factory/tpe/household_schema.json';

export const getTPESteps = (matchPath, contractRequest) => {
  const getTarificationStep = (vehicle_kind) => {
    const tarification = contractRequest.tarifications[0];
    return {
      path:              `${ matchPath }/${vehicle_kind}s_tarification_${ tarification.id }`,
      title:             t(`wizard.${vehicle_kind}s.title`),
      disabledRules:     [
        new Condition({
          property:   `contract_request.data.risk_types.${vehicle_kind}s`,
          assertion: 'isTrue',
        })
      ],
      label:             t(`wizard.navigation.${vehicle_kind}s`),
      error:             tarification.last_error_response,
      loading:           tarification.computing,
      tarification_data: {
        updated_at: tarification.updated_at,
        id:         tarification.id,
      },
      purpose:           `tarification_${ tarification.product.slug }`,
      Component:         (props) => {
        return (
          <TarificationStep { ...props } tarificationId={ tarification.id } formComponent={ getAxaFleetTarificationForm(vehicle_kind) } />
        );
      },
    };
  };

  return [
    {
      order: 1,
      label: t('wizard.navigation.about_contract_request'),
      icon:  'file',
      slug:  'contract_request',
      kind:  'group',
      steps: [
        {
          order:          1,
          path:           `${ matchPath }/policy_owner`,
          title:          t('wizard.policy_owner.title'),
          label:          t('wizard.navigation.policy_owner'),
          purpose:        'policy_owner_step',
          icon:           'company',
          Component:      ProductFactoryStep,
          componentProps: {
            stepSchema: {
              ...policyOwnerSchema,
            },
            onNextStep: {
              refreshTarifications: false,
            },
          },
        },
        {
          order:          2,
          path:           `${ matchPath }/guarantee_types`,
          title:          t('wizard.guarantee_types.title'),
          label:          t('wizard.navigation.guarantee_types'),
          purpose:        'guarantee_types_step',
          icon:           'folder',
          Component:      ProductFactoryStep,
          componentProps: {
            stepSchema: {
              ...guaranteeTypesSchema,
            },
            onNextStep: {
              refreshTarifications: false,
            },
          },
        },
        {
          order:          3,
          path:           `${ matchPath }/worker_compensation`,
          title:          t('wizard.worker_compensation.title'),
          label:          t('wizard.navigation.worker_compensation'),
          purpose:        'worker_compensation_step',
          icon:           'car',
          displayRules:   [
            new Condition({
              property:  'contract_request.data.guarantee_types.worker_compensation',
              assertion: 'isTrue',
            })
          ],
          Component:      ProductFactoryStep,
          componentProps: {
            stepSchema: {
              ...workerCompSchema,
            },
            onNextStep: {
              refreshTarifications: true,
            },
          },
        },
        {
          order:          4,
          path:           `${ matchPath }/complementary_law`,
          title:          t('wizard.complementary_law.title'),
          label:          t('wizard.navigation.complementary_law'),
          purpose:        'complementary_law_step',
          icon:           'van',
          displayRules:   [
            new Condition({
              property:  'contract_request.data.guarantee_types.complementary_law',
              assertion: 'isTrue',
            })
          ],
          Component:      ProductFactoryStep,
          componentProps: {
            stepSchema: {
              ...complementaryLawSchema,
            },
            onNextStep: {
              refreshTarifications: true,
            },
          },
        },
        {
          order:          5,
          path:           `${ matchPath }/household`,
          title:          t('wizard.household.title'),
          label:          t('wizard.navigation.household'),
          purpose:        'household_step',
          icon:           'house',
          displayRules:   [
            new Condition({
              property:  'contract_request.data.guarantee_types.household',
              assertion: 'isTrue',
            })
          ],
          Component:      ProductFactoryStep,
          componentProps: {
            stepSchema: {
              ...householdSchema,
            },
            onNextStep: {
              refreshTarifications: true,
            },
          },
        },
      ],
    },

    getTarificationSteps(contractRequest, matchPath, [], [], 19),

    // {
    //   kind:  'group',
    //   label: t('wizard.navigation.product_configuration'),
    //   icon:  'actions',
    //   slug:  'tarifications',
    //   order: 20,
    //   steps: [
    //     getTarificationStep('car'),
    //     getTarificationStep('van'),
    //   ],
    // }

  ];
};
